import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const OpenDetailsIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType & { backgroundColor?: string }) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.6569 6.34311H10.4161M17.6569 6.34311V13.5839M17.6569 6.34311L6.34316 17.6568"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Box>
  );
};
